/* eslint-disable react/no-unescaped-entities */
/* eslint-disable @typescript-eslint/no-explicit-any */

import {
  StyledCustomOl,
  StyledH1,
  StyledParagraph,
  StyledStrong,
  StyledStrongParagraph,
  StyledUl,
  StyledUlParagraph,
} from './styles';

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const TermOfUseScreen: React.FC<any> = () => {
  // =============== VIEWS
  return (
    <div>
      <div>
        <StyledH1>Term Of Use</StyledH1>
        <StyledStrongParagraph>
          <StyledStrong>Terms of Usage</StyledStrong>
        </StyledStrongParagraph>
        <StyledParagraph>
          CariCarz Sdn. Bhd. (Registration No. 202001010090 (1366410-H)) is the
          owner and operator of the automotive platform known as “Caricarz”
          (hereinafter “CariCarz”, “we”, “our”, “us”) which allows Dealers (as
          hereinafter defined) to advertise, list, offer, sell or make available
          motor vehicles (“Vehicles”) to its Users (as hereinafter defined) on
          the domain with the name of https://www.caricarz.com/ (the “Platform”)
          in accordance with these Terms of Use, and any other terms and
          conditions and privacy policy posted on the Platform from time to
          time(collectively, the “Terms”).
          <br />
          <br />
          These Terms govern the User’s access and use of the Platform and the
          use of any services, information and functions made available by us at
          the Platform (“Services”). Before using this Platform or the Services,
          the User must read carefully and accept these Terms and the User must
          consent to the processing of the User’s personal data as described in
          the privacy policy posted on the Platform.
        </StyledParagraph>

        <StyledStrongParagraph>
          <StyledStrong>General Term</StyledStrong>
        </StyledStrongParagraph>
        <StyledUlParagraph>
          By accessing the Platform, registering an account (“Account”) and/or
          using the Services, you agree to be bound by these Terms which shall
          be applicable to all users of the Platform and any amendments to the
          foregoing issued by Caricarz from time to time. If you do not agree to
          these Terms, please do not access and/or use the Platform and/or the
          Services.
          <br />
          <br />
          If the User is under the age of 18 or the legal age for giving consent
          hereunder pursuant to the Applicable Laws in the User’s country, the
          User must obtain permission from his/her parent(s) or legal
          guardian(s) to open an account on the Platform. If the User is the
          parent or legal guardian of a minor who is creating an account, the
          User must accept and comply with these Terms on the minor's behalf and
          the User will be responsible for the minor’s actions, any charges
          associated with the minor’s use of the Platform and/or Services or
          purchases made on the Platform. If the User does not have consent from
          his/her parent(s) or legal guardian(s), the User must stop
          using/accessing this Platform and/or Services.
          <br />
          <br />
          Under no circumstances shall Caricarz be liable for any direct,
          indirect, special, incidental or consequential damages, including, but
          not limited to, loss of data or profit, arising out of the use, or the
          inability to use, the materials on this site, even if Caricarz or its
          authorized representative has been advised of the possibility of such
          damages. If your use of materials from this Platform results in the
          need for servicing, repair or correction of equipment or data, you
          shall assume any costs thereof.
          <br />
          <br />
          We will not be responsible for any outcome that may occur during the
          course of usage of our resources. We reserve the rights to:
          <br />
        </StyledUlParagraph>
        <StyledCustomOl>
          <li>
            change, amend, modify, add or remove these Terms at any time and the
            revised version will be effective immediately once it is displayed
            on the Platform with no other notices provided to the User. By
            continuing to use the Platform, the User shall be bound by any
            revisions to these Terms.
          </li>
          <li>
            change, modify, suspend or discontinue all or any part of the
            Platform and Service at any time. We may also impose limits on
            certain features or restrict your access to parts of, or the entire,
            in our sole discretion without notice or liability
          </li>
        </StyledCustomOl>
        <br />
        <br />

        <StyledStrongParagraph>
          <StyledStrong>Definitions</StyledStrong>
        </StyledStrongParagraph>
        <StyledUlParagraph>
          The following terms shall have the following respective meanings:
        </StyledUlParagraph>
        <StyledCustomOl type="a">
          <li>
            “Applicable Laws” means with respect to any person, any and all
            applicable constitutions, treaties, statutes, laws, by-laws,
            regulations, ordinances, codes, rules, rulings, judgments, rules of
            common law, orders, decrees, awards, injunctions or any form of
            decisions, determinations or requirements of or made or issued by,
            governmental, statutory, regulatory, administrative, supervisory or
            judicial authorities or bodies (including without limitation, any
            relevant stock exchange or securities council) or any court,
            arbitrator or tribunal with competent jurisdiction and to which such
            person is subject;
          </li>
          <li>
            “Business Day” means a day on which banks are open for business in
            Selangor (other than a Saturday or Sunday or gazetted public
            holidays);
          </li>
          <li>
            “Cookies” means small amount of data generated by a website and
            saved by your web browser. It is used to identify your browser,
            provide analytics, remember information about you such as your
            language preference or login information;
          </li>
          <li>
            “Dealers” means the sellers, dealers and/or vendors of the Vehicles
            and/or the party posting the advertisement and/or classified on the
            Platform and “Dealer” shall be construed accordingly;
          </li>
          <li>
            “Buyer”, “User”, "you" or “your”, means the person accessing or
            using the Platform or the Services or purchasing the Vehicle from
            any of the Dealers via the Platform and it shall be construed
            accordingly.
          </li>
        </StyledCustomOl>
        <br />
        <br />

        <StyledStrongParagraph>
          <StyledStrong>Account and Security</StyledStrong>
        </StyledStrongParagraph>
        <StyledParagraph>
          To use the Services, the User is required to create an account on the
          Platform in order to gain access to the use of any services and
          functionality at the Platform that Caricarz may establish and maintain
          at all material times and in its sole discretion.
          <br />
          <br />
          The User’s permission to use the Platform and/or the Services is
          conditional upon he User’s agreement that the User will provide
          accurate information when creating an account or registering with
          Caricarz. Caricarz has the absolute discretion to reject, approve,
          suspend or terminate the User’s creation of an account with Caricarz
          and/or the User’s usage of the Platform and/or Services.
          <br />
          <br />
          The User hereby acknowledges and consents that Caricarz may access,
          preserve and disclose the User account information and Contents (as
          defined below) to any legal regulatory, or government authority, the
          relevant rights owner, or third parties if required to do so by the
          Applicable Laws pursuant to an order of court or lawful request by any
          governmental or regulatory authority having jurisdiction over Caricarz
          in accordance with the terms of the privacy policy at
          https://www.caricarz.com/privacy-policy.
          <br />
          <br />
          The User is solely responsible for the activity that occurs on the
          User’s account even if such activities or uses were not committed by
          the User, and the User must keep its account password secure. If a
          legal dispute or law enforcement action is commenced related to the
          User’s account for any reason, Caricarz may suspend and/or terminate
          the User’s account immediately with or without notice. Caricarz shall
          not be responsible or liable, directly or indirectly, in any way for
          any loss or damage of any kind incurred as a result of, or in
          connection with, the User’s failure to comply with this section.
          <br />
          <br />
          The User must notify Caricarz immediately of any breach of security or
          unauthorized use of its account. Caricarz shall not be liable for any
          losses caused by any unauthorized use of the User’s account.
        </StyledParagraph>

        <StyledStrongParagraph>
          <StyledStrong>
            Conditional Use of Our Platform and Services
          </StyledStrong>
        </StyledStrongParagraph>
        <StyledParagraph>
          Caricarz grants you a limited, revocable, non-exclusive,
          non-transferable, non-assignable, non-licensable right to access, view
          and use the Platform as well as the Services to in accordance with the
          Terms. Any breach of these Terms may result in the immediate
          revocation of the license granted herein without notice to the User.
          <br />
          <br />
          The Vehicles, specifications, information and/or descriptions
          expressed on the Platform are those of the Dealers and are not made by
          the Platform. Caricarz is not liable for any loss or damage the User
          may suffer as a result of the publishing of inaccurate, misleading or
          fake information by the Dealers or any omission of information.
          <br />
          <br />
          The Dealer is solely responsible for the price and quality of its
          respective Vehicle, specifications, information and/or descriptions
          posted by the Dealer in relation to the Vehicle, and compliance with
          the Applicable Laws, including laws with respect to taxes and
          insurance.
          <br />
          <br />
          Caricarz is not responsible for additional or different terms,
          conditions, limitations and restrictions that may be imposed by the
          Dealer on the Vehicle. In the event that the Dealer refuses to honour
          the Vehicle without cause or contrary to law or these Terms or for any
          reason whatsoever, the User may have a recourse against the Dealer and
          Caricarz shall not be held liable for the Dealer’s default. Caricarz
          also reserves the right at its sole discretion, to cancel, terminate
          or alter the information of any Vehicles to its accuracy at any time.
        </StyledParagraph>

        <StyledUlParagraph>
          <StyledStrong>Mere Platform</StyledStrong>
          <br />
          The User hereby acknowledges and agrees that the Platform is merely a
          platform which provides a place and opportunity for the sale and
          purchase of the Vehicle between a prospective Dealer and a prospective
          User. Caricarz does not own, operate or control any of the Vehicle
          that is listed, offered and/or supplied by the Dealer.
          <br />
          <br />
          In this connection, the User is responsible to conduct his/her own due
          diligence with respect to whether the Vehicle offered or provided by
          the Dealer is original, of merchantable quality, genuine and/or meets
          the specifications and conditions as prescribed by the Dealer.
          <br />
          <br />
          In particular but without derogation to the other provisions of these
          Terms, Caricarz is not responsible or liable for any of the following:
        </StyledUlParagraph>
        <StyledUl>
          <li>
            the quality, safety, morality or legality of any aspect of the
            Vehicle listed on the Platform;
          </li>
          <li>
            the truth or accuracy of the listing(s) on the Platform, the ability
            of the Dealer to sell the Vehicle or the ability of User to purchase
            for the Vehicle;
          </li>
          <li>
            any claim that a User may have in respect of the Vehicle and matters
            incidental thereto; and{' '}
          </li>
          <li>
            the accuracy and/or omission (whether material or otherwise) of any
            Listing posted, featured and/or published on the Platform
          </li>
        </StyledUl>
        <StyledParagraph>
          The User hereby agrees that the actual contract for sale of the
          Vehicle is directly between the Dealer and the User and Caricarz is
          not a party to that or any other contract between the Dealer and the
          User and accepts no obligations in connection with any such contract.
          Parties to such transaction will be entirely responsible for the sale
          and purchase contract between them, the listing of goods and warranty
          of purchase. Caricarz is not a party in the transaction between the
          Dealer and the User.
          <br />
          <br />
          Caricarz cannot guarantee continuous or secure access to our Services,
          and operation of the Platform may be interfered with by numerous
          factors outside of Caricarz’s control. Accordingly, to the extent
          legally permitted, Caricarz makes no representations or warranties of
          any kind with respect to the systems operated by Caricarz or any
          software and hardware provided, or any part thereof, express or
          implied, and shall not be liable for any loss of money, goodwill, or
          reputation, or any special, indirect, or consequential damages which
          may be suffered or incurred by the Dealer or the User or any third
          party in connection with the use of the Platform including (without
          prejudice to the generality of the foregoing) any loss of profit in
          consequence of a breakdown in providing the Services or part thereof.
        </StyledParagraph>

        <StyledUlParagraph>
          <StyledStrong>Restrictions</StyledStrong>
          <br />
          You agree not to, and you will not permit others to:
          <br />
        </StyledUlParagraph>
        <StyledUl>
          <li>
            License, sell, rent, lease, assign, distribute, transmit, host,
            outsource, disclose or otherwise commercially exploit the service or
            make the platform available to any third party.
          </li>
          <li>
            Modify, make derivative works of, disassemble, decrypt, reverse
            compile or reverse engineer any part of the service.
          </li>
          <li>
            Remove, alter or obscure any proprietary notice (including any
            notice of copyright or trademark) of or its affiliates, partners,
            suppliers or the licensors of the service.
          </li>
        </StyledUl>
        <br />
        <br />
        <StyledStrongParagraph>
          <StyledStrong>Payment</StyledStrong>
        </StyledStrongParagraph>
        <StyledParagraph>
          The User should carefully read the descriptions, details and review
          information such as specifications, price, option price, charges, and
          such other terms and conditions for the Vehicle before purchasing such
          Vehicle. Subject to the sale and purchase agreement entered between
          the Dealer and the User, the User agrees to make prompt payment to the
          Dealer. You agree that Caricarz is not involved in transaction which
          is considered solely between the User and the Dealer, Caricarz cannot
          ensure that the User or the Dealer would follow through and complete
          the transaction.
        </StyledParagraph>

        <StyledStrongParagraph>
          <StyledStrong>Delivery</StyledStrong>
        </StyledStrongParagraph>
        <StyledParagraph>
          The Dealers are solely responsible for delivering the sold Vehicle to
          the Users subject to the sale and purchase agreement entered between
          the Dealer and the User. You acknowledge and agree that Caricarz has
          no control over any delivery of the Vehicles sold through the
          Platform, including but not limited to the delivery fees, method
          specified by the Dealers, any delays, delivery failures, damages, or
          losses resulting from the delivery.
        </StyledParagraph>

        <StyledStrongParagraph>
          <StyledStrong>Return and Refund Policy</StyledStrong>
        </StyledStrongParagraph>
        <StyledParagraph>
          Should there be any dispute or conflict arising from or incidental to
          the return or refund of the Vehicle, the User shall communicate and
          negotiate with the Dealer directly to resolve such dispute or
          conflict. Caricarz shall not be held liable on occurrence which may
          give rise to product liability or liability for breach of warranty
          (whether covered by insurance or not) on the part of us, with respect
          to the Vehicle designed, manufactured, assembled, repaired,
          maintained, delivered, distributed or installed or services rendered
          prior to or on the date of purchase. The liability shall stay solely
          with the Dealers or any party providing such warranties.
        </StyledParagraph>

        <StyledStrongParagraph>
          <StyledStrong>Premium Selection Vehicle</StyledStrong>
        </StyledStrongParagraph>
        <StyledParagraph>
          All vehicle under the premium selection will be supplied with a 5 days
          money back guarantee provided by the Dealer ("Guarantee"). The User
          reserves the right to request the Dealer to re-purchase the Vehicle
          from the User and return the purchase price paid by the User in full
          in the event that the Vehicle has been damaged by fire or water or is
          reported as a cut-and-joint car, within five (5) days from the date
          the User collects the Vehicle from the Dealer. Caricarz shall be
          entitled to appoint an expert to determine the state and condition of
          the car and the decision of such expert shall be final and binding.
          <br />
          <br />
          Caricarz shall not be held liable to the Guarantee supplied by the
          Dealer and Caricarz makes no condition, representation or warranty of
          any kind regarding the suitability of the Platform content, Vehicle
          and/or its specifications, information and descriptions. Caricarz
          expressly disclaims any and all conditions, representations and
          warranties of merchantability or fitness for particular use, including
          all implied warranties in connection with the foregoing. Caricarz also
          expressly disclaims any condition, warranty or representation as to
          the accuracy, results, timelines and/or completeness of all the
          postings by the Dealer, the report produced in relation to the Vehicle
          and all other content available on or through the Platform.
          <br />
          <br />
          The User’s recourse for the Guarantee and for any matter related to
          the Vehicle shall lie with and against the Dealer.
        </StyledParagraph>

        <StyledStrongParagraph>
          <StyledStrong>User Submissions</StyledStrong>
        </StyledStrongParagraph>
        <StyledUlParagraph>
          Any feedback, comments, ideas, improvements, suggestions, reviews,
          ratings, photographs, videos, ideas (collectively, "Content") provided
          by you to us with respect to the Service and/or the Vehicle shall
          remain the sole and exclusive property of us. We shall be free to use,
          copy, modify, publish, or redistribute the Suggestions for any purpose
          and in any way without any credit or any compensation to you.
          <br />
          <br />
          The User further agrees and warrants that the User shall not submit
          any Content:
          <br />
        </StyledUlParagraph>
        <StyledUl>
          <li>
            That is known by the User to be false, inaccurate or misleading.
          </li>
          <li>
            That infringes any third party's copyright, patent, trademark, trade
            secret or any other intellectual or proprietary rights or rights of
            publicity or privacy.
          </li>
          <li>
            That breaches any Applicable Laws (including, but not limited to,
            those governing export control, consumer protection, unfair
            competition, anti-discrimination or false advertising).
          </li>
          <li>
            That discloses private information of any third party, including
            without limitation, addresses, phone numbers, email addresses,
            national insurance numbers and credit card numbers, or otherwise
            violates the rights of any third party, including without
            limitation, privacy rights.
          </li>
          <li>
            That is, or may reasonably be considered to be, defamatory,
            libellous, hateful, racially or religiously biased or offensive,
            unlawfully threatening or harassing or discriminatory based on sex
            or gender to any of the Merchant and/or third party.
          </li>
          <li>
            That is offensive, profane, vulgar, obscene or inappropriate
            language.
          </li>
          <li>
            That impersonates, or misrepresents the User’s connection with, any
            entity or person.
          </li>
          <li>
            That contains any computer viruses, worms or other potentially
            damaging computer programs or files.
          </li>
        </StyledUl>
        <StyledUlParagraph>
          <br />
          The User agrees that the User be solely responsible for the Content of
          its submission, and any comments the User makes. The User shall be
          solely liable for any damages resulting from any breach by the User
          from any harm resulting from the User’s submission of Content.
          Caricarz does not represent or warrant that any Content submitted by
          the User is accurate, and or that it is free from mistakes, omissions,
          falsehoods, defamation, obscenity, pornography or profanity.
          <br />
          <br />
          The User agrees to indemnify Caricarz (and its officers, directors,
          employees, affiliates, agents, subsidiaries, joint ventures, dealers,
          and any third-party service provider) and keep Caricarz indemnified
          from any and all losses, damages (actual and consequential),
          liabilities (whether criminal or civil), claims, disputes, demands,
          causes of actions, costs and expenses (including reasonable legal fees
          and expenses), fines, or penalties of every kind and nature, known and
          unknown, arising out of, in connection with, or related to: (i) the
          User’s Content; (ii) any breach of the User’s representations and
          warranties as set out above; and/or (iii) any breach of any Applicable
          Laws, or the User’s interference with the rights of a third party.
          <br />
          <br />
          The User understands the Platform is public and that if the User posts
          any Content, Caricarz may use, modify, edit, delete, translate or
          republish such Content and that the User agrees that any submission is
          non-confidential and non-proprietary and may be used in any manner or
          medium whatsoever by Caricarz. For the avoidance of doubt, Caricarz
          shall have the right, but not the obligation, to pursue any one or
          more of the following actions with regard to the User’s submissions
          and the User’s interactions via the Platform:
        </StyledUlParagraph>
        <StyledUl>
          <li>to monitor or review the User’s submission of Content;</li>
          <li>
            to remove or refuse to post any Content within the Platform that
            Caricarz deems, in its sole discretion, which violates the
            submission guidelines as may be prescribed by Caricarz; and
          </li>
          <li>
            to suspend or terminate the User’s access to the submission of
            Content on the Platform as Caricarz deems appropriate in the
            circumstances.
          </li>
        </StyledUl>
        <br />
        <br />
        <StyledStrongParagraph>
          <StyledStrong>Links to Other Websites</StyledStrong>
        </StyledStrongParagraph>
        <StyledParagraph>
          Our Platform may contain links to other websites that are not operated
          by us ("Third-Party Websites”). We do not control the Third-Party
          Websites to which our links and assumes no responsibility for their
          content, terms and conditions or privacy policies and/or statements.
          Third-Party Websites and links thereto are provided solely as a
          convenience to you and you access and use them entirely at your own
          risk and subject to such third parties' terms and conditions. This
          includes any company providing online payment via credit card or
          e-banking.
        </StyledParagraph>

        <StyledStrongParagraph>
          <StyledStrong>Cookies</StyledStrong>
        </StyledStrongParagraph>
        <StyledParagraph>
          We use "Cookies" to identify the areas of our Platform that you have
          visited. A Cookie is a small piece of data stored on your computer or
          mobile device by your web browser. We use Cookies to enhance the
          performance and functionality of our Service but are non-essential to
          their use. However, without these cookies, certain functionality like
          videos may become unavailable or you would be required to enter your
          login details every time you visit our Platform as we would not be
          able to remember that you had logged in previously. Most web browsers
          can be set to disable the use of Cookies. However, if you disable
          Cookies, you may not be able to access functionality on our Platform
          correctly or at all. Like many web site operators, we also use the
          independent companies to measure and analyse the internet usage across
          the Platform. This aggregate, non-personal data is collected by such
          independent companies provided to us to assist in analysing the usage
          of the Platform. We also collect Internet Protocol (IP) addresses. IP
          addresses are assigned to computers on the internet to uniquely
          identify them within the global network. We collect and manage IP
          addresses as part of the service of providing internet session
          management and for security purposes.
        </StyledParagraph>

        <StyledStrongParagraph>
          <StyledStrong>Updates to Our service</StyledStrong>
        </StyledStrongParagraph>
        <StyledParagraph>
          We may from time to time provide enhancements or improvements to the
          features/ functionality of the service, which may include patches, bug
          fixes, updates, upgrades and other modifications ("Updates"). Updates
          may modify or delete certain features and/or functionalities of the
          service. You agree that we have no obligation to (i) provide any
          Updates, or (ii) continue to provide or enable any particular features
          and/or functionalities of the service to you. You further agree that
          all Updates will be (i) deemed to constitute an integral part of the
          service, and (ii) subject to these terms and conditions.
        </StyledParagraph>

        <StyledParagraph>
          <StyledStrong>Term and Termination</StyledStrong>
        </StyledParagraph>
        <StyledParagraph>
          This Agreement shall remain in effect until terminated by you or us.
          We may, in its sole discretion, at any time and for any or no reason,
          suspend or terminate this Agreement with or without prior notice. This
          Agreement will terminate immediately, without prior notice from us, in
          the event that you fail to comply with any provision of these Terms
          and/or any other terms and conditions or policies which may posted by
          us from time to time. You may also terminate this Agreement by
          deleting your account and all copies thereof from your computer. Upon
          termination of this Agreement, you shall cease all use of the Services
          and delete all copies of the Services from your computer. Termination
          of this Agreement will not limit any of our rights or remedies at law
          or in equity in case of breach by you (during the term of this
          Agreement) of any of your obligations under the present Agreement.
          <br />
          <br />
          You acknowledge and agree that if you deactivate your account or if we
          suspend or terminate your account, you will lose any information
          associated with your account, including Contents. Upon termination,
          all licenses and rights granted to you in these Terms will immediately
          cease.
        </StyledParagraph>

        <StyledStrongParagraph>
          <StyledStrong>Infringement of Copyright</StyledStrong>
        </StyledStrongParagraph>
        <StyledParagraph>
          If you are a copyright owner or such owner’s agent and believe any
          material from us constitutes an infringement on your copyright, please
          contact us setting forth the following information: (a) a physical or
          electronic signature of the copyright owner or a person authorized to
          act on his behalf; (b) identification of the material that is claimed
          to be infringing; (c) your contact information, including your
          address, telephone number, and an email; (d) a statement by you that
          you have a good faith belief that use of the material is not
          authorized by the copyright owners; and (e) a statement that the
          information in the notification is accurate, and, under penalty of
          perjury you are authorized to act on behalf of the owner.
        </StyledParagraph>

        <StyledStrongParagraph>
          <StyledStrong>Indemnification</StyledStrong>
        </StyledStrongParagraph>
        <StyledParagraph>
          You agree to defend, indemnify and hold us and our parents,
          subsidiaries, affiliates, directors, officers, employees, agents,
          partners, successors, assignees and licensors (if any) harmless from
          and against any claim, demand, liabilities, damages, costs, judgments,
          losses or expenses (including reasonable legal fees on a full
          indemnity basis), arising out of or in connection with: (a) use of the
          service; (b) violation of these Terms or any Applicable Laws; (c)
          violation of any right of a third party; or (d) Caricarz’s enforcement
          or attempt to enforce the obligations of the User; other than where
          any such claim, liabilities, damages, costs, judgments losses or
          expenses arises solely as a result of Caricarz’s negligence.
          <br />
          <br />
          Notwithstanding any other provision herein, it is agreed that neither
          party shall be liable to the other party for any loss of profit,
          goodwill, business opportunity, and anticipated savings or for any
          indirect, special or consequential loss or damage suffered or flowing
          from this Terms, even if reasonably contemplated or if such other
          party has been advised of the possibility of such loss or damage.
        </StyledParagraph>

        <StyledStrongParagraph>
          <StyledStrong>No Warranties</StyledStrong>
        </StyledStrongParagraph>
        <StyledParagraph>
          You acknowledge and agree that the Services are provided on an "AS IS"
          and "AS AVAILABLE" basis to you and with all faults and defects
          without warranty of any kind, and that your use of or reliance upon
          the Services and any content, products or services accessed or
          obtained thereby is at your sole risk and discretion. To the maximum
          extent permitted under applicable law, we, on our own behalf and on
          behalf of our affiliates and our respective licensors and service
          providers, expressly disclaims all warranties, whether express,
          implied, statutory or otherwise, with respect to the Services and/or
          the Vehicles, including all implied warranties of merchantability,
          fitness for a particular purpose, title and non- infringement, and
          warranties that may arise out of course of dealing, course of
          performance, usage or trade practice. Without limitation to the
          foregoing, we provide no warranty or undertaking, and makes no
          representation of any kind that the Services will meet your
          requirements, achieve any intended results, be compatible or work with
          any other software, websites, systems or services, operate without
          interruption, meet any performance or reliability standards or be
          error free or that any errors or defects can or will be corrected.
          <br />
          <br />
          Without limiting the foregoing, neither us nor any provider makes any
          representation or warranty of any kind, express or implied: (i) as to
          the operation or availability of the service, or the information,
          content, and materials or products included thereon; (ii) that the
          service will be uninterrupted or error-free; (iii) as to the accuracy,
          reliability, or currency of any information or content provided
          through the service; or (iv) that the service, its servers, the
          content, or e-mails sent from or on behalf of us are free of viruses,
          scripts, trojan horses, worms, malware, timebombs or other harmful
          components. Some jurisdictions do not allow the exclusion of or
          limitations on implied warranties or the limitations on the applicable
          statutory rights of a consumer, so some or all of the above exclusions
          and limitations may not apply to you.
        </StyledParagraph>

        <StyledStrongParagraph>
          <StyledStrong>Limitation of Liability</StyledStrong>
        </StyledStrongParagraph>
        <StyledParagraph>
          You acknowledge and agree that your only right with respect to any
          problem or dissatisfaction with the Services is to request for
          termination of your account and/or discontinue any use of the
          Services. In no event shall Caricarz or its subsidiaries, affiliates,
          partners, suppliers or licensors be liable for any indirect,
          incidental, consequential, special or exemplary damages arising out of
          or in connection with your access or use of or inability to access or
          use the Services or any third party content and services, or arising
          out of or in connection with your conduct or the conduct of other
          users in connection with the use of the Services including without
          limitation death, bodily injury, emotional distress and/or other
          damages resulting from communications or meetings with other users or
          persons you meet through the Services, whether or not the damages were
          foreseeable and whether or not Caricarz was advised of the possibility
          of such damages. Without limiting the generality of the foregoing,
          Caricarz’s aggregate liability to you (whether under contract, tort,
          statute or otherwise) shall not exceed the amount of fees received by
          Caricarz in respect of the Services giving rise to such claims or,
          where relevant, shall not exceed the amount of Malaysia Ringgit then
          standing to the Caricarz’s credit in your account. The foregoing
          limitations will apply even if the above stated remedy fails of its
          essential purpose. Some states/jurisdictions do not allow the
          exclusion or limitation of incidental or consequential damages, so the
          above limitation or exclusion may not apply to you.
        </StyledParagraph>

        <StyledStrongParagraph>
          <StyledStrong>Severability</StyledStrong>
        </StyledStrongParagraph>
        <StyledParagraph>
          If any provision of this Agreement is held to be unenforceable or
          invalid, such provision will be changed and interpreted to accomplish
          the objectives of such provision to the greatest extent possible under
          applicable law and the remaining provisions will continue in full
          force and effect.
          <br />
          <br />
          These Terms, together with the Privacy Policy and any other legal
          notices published by us on the Platform, shall constitute the entire
          agreement between you and us concerning the Services. If any provision
          of this Agreement is deemed invalid by a court of competent
          jurisdiction, the invalidity of such provision shall not affect the
          validity of the remaining provisions of this Agreement, which shall
          remain in full force and effect. YOU AND US AGREE THAT ANY CAUSE OF
          ACTION ARISING OUT OF OR RELATED TO THE SERVICES MUST COMMENCE WITHIN
          ONE (1) YEAR AFTER THE CAUSE OF ACTION ACCRUES. OTHERWISE, SUCH CAUSE
          OF ACTION IS PERMANENTLY BARRED.
        </StyledParagraph>

        <StyledStrongParagraph>
          <StyledStrong>Waiver</StyledStrong>
        </StyledStrongParagraph>
        <StyledParagraph>
          Except as provided herein, the failure to exercise a right or to
          require performance of an obligation under this Agreement shall not
          effect a party's ability to exercise such right or require such
          performance at any time thereafter nor shall be the waiver of a breach
          constitute waiver of any subsequent breach.
          <br />
          <br />
          No failure to exercise, and no delay in exercising, on the part of
          either party, any right or any power under this Agreement shall
          operate as a waiver of that right or power. Nor shall any single or
          partial exercise of any right or power under this Agreement preclude
          further exercise of that or any other right granted herein. In the
          event of a conflict between this Agreement and any applicable purchase
          or other terms, the terms of this Agreement shall govern.
        </StyledParagraph>

        <StyledStrongParagraph>
          <StyledStrong>Entire Agreement</StyledStrong>
        </StyledStrongParagraph>
        <StyledParagraph>
          The Agreement constitutes the entire agreement between you and us
          regarding your use of the service and supersedes all prior and
          contemporaneous written or oral agreements between you and us. You may
          be subject to additional terms and conditions that apply when you use
          or purchase other services from us, which we will provide to you at
          the time of such use or purchase.
        </StyledParagraph>

        <StyledStrongParagraph>
          <StyledStrong>Intellectual Property</StyledStrong>
        </StyledStrongParagraph>
        <StyledParagraph>
          You acknowledge and agree that the Services, the Platform and its
          entire contents, features and functionality (including but not limited
          to all information, software, text, displays, images, video and audio,
          and the design, selection and arrangement thereof), are owned by us,
          its licensors or other providers of such material and are protected by
          and international copyright, trademark, patent, trade secret and other
          intellectual property or proprietary rights laws. The material may not
          be copied, modified, reproduced, downloaded or distributed in any way,
          in whole or in part, without the express prior written permission of
          us, unless and except as is expressly provided in these Terms &
          Conditions. Any unauthorized use of the material is prohibited.
        </StyledParagraph>

        <StyledStrongParagraph>
          <StyledStrong>Agreement to Arbitrate</StyledStrong>
        </StyledStrongParagraph>
        <StyledParagraph>
          This section applies to any dispute EXCEPT IT DOESN’T INCLUDE A
          DISPUTE RELATING TO CLAIMS FOR INJUNCTIVE OR EQUITABLE RELIEF
          REGARDING THE ENFORCEMENT OR VALIDITY OF YOUR OR ‘s INTELLECTUAL
          PROPERTY RIGHTS. The term “dispute” means any dispute, action, or
          other controversy between you and us concerning the Services or this
          agreement, whether in contract, warranty, tort, statute, regulation,
          ordinance, or any other legal or equitable basis. “Dispute” will be
          given the broadest possible meaning allowable under law.
        </StyledParagraph>

        <StyledStrongParagraph>
          <StyledStrong>Notice of Dispute</StyledStrong>
        </StyledStrongParagraph>
        <StyledParagraph>
          In the event of a dispute in relation to the Services, the disputing
          Party must give the other a notice of dispute, which is a written
          statement that sets forth the name, address, and contact information
          of the party giving it, the facts giving rise to the dispute, and the
          relief requested ("Notice of Dispute”). You must send any Notice of
          Dispute to us via email to:support@caricarz.com. We will send any
          Notice of Dispute to you by mail to your address if we have it, or
          otherwise to your email address. Parties will attempt to resolve any
          dispute through informal negotiation within sixty (60) days from the
          date the Notice of Dispute is sent. Should the Parties fail to reach
          an amicable arrangement after sixty (60) days, both Parties may
          commence arbitration.
        </StyledParagraph>

        <StyledStrongParagraph>
          <StyledStrong>Binding Arbitration</StyledStrong>
        </StyledStrongParagraph>
        <StyledParagraph>
          If you and us don’t resolve any dispute by informal negotiation, any
          other effort to resolve the dispute will be conducted exclusively by
          binding arbitration as described in this section. You are giving up
          the right to litigate (or participate in as a party or class member)
          all disputes in court before a judge or jury. The dispute shall be
          settled by binding arbitration in accordance with the Asian
          International Arbitration Centre in Kuala Lumpur (AIAC) in force on
          the date when the Notice of Arbitration is submitted in accordance
          with these Rules. The number of arbitrators shall be one. The seat of
          arbitration shall be Kuala Lumpur and the arbitration shall apply
          substantive law of Malaysia. The arbitral proceedings shall be
          conducted in English language.
        </StyledParagraph>

        <StyledStrongParagraph>
          <StyledStrong>Promotions</StyledStrong>
        </StyledStrongParagraph>
        <StyledParagraph>
          We may, from time to time, include contests, promotions, sweepstakes,
          or other activities (“Promotions”) that require you to submit material
          or information concerning yourself. Please note that all Promotions
          may be governed by separate rules that may contain certain eligibility
          requirements, such as restrictions as to age and geographic location
          ("Promotions Rules”). You are responsible to read all Promotions Rules
          to determine whether or not you are eligible to participate. If you
          enter any Promotion, you agree to abide by and to comply with all
          Promotions Rules. Additional terms and conditions may apply to
          purchases of goods or services on or through the Services, which terms
          and conditions are made a part of this Agreement by this reference.
          Under certain circumstances, Caricarz may, at its sole discretion, at
          any time and without prior notice to the User, withdraw, modify,
          suspend, cancel or delete all, or a part of the Promotion or the
          Promotions Rules governing such Promotion.
        </StyledParagraph>

        <StyledStrongParagraph>
          <StyledStrong>Typographical Errors</StyledStrong>
        </StyledStrongParagraph>
        <StyledParagraph>
          In the event a Vehicle is listed at an incorrect price or with
          incorrect information due to typographical error, we shall have the
          right to refuse or cancel any orders placed for the Vehicle listed at
          the incorrect price. We shall have the right to refuse or cancel any
          such order whether or not the order has been confirmed and the payment
          has been made. If the User has already made any payment for the
          purchase and such order is canceled, the Dealer shall immediately
          issue a credit to the User’s payment account in the amount of the
          charge.
        </StyledParagraph>

        <StyledStrongParagraph>
          <StyledStrong>Miscellaneous</StyledStrong>
        </StyledStrongParagraph>
        <StyledParagraph>
          If for any reason a court of competent jurisdiction finds any
          provision or portion of these Terms to be unenforceable, the remainder
          of these Terms will continue in full force and effect. Any waiver of
          any provision of these Terms will be effective only if in writing and
          signed by an authorized representative of us. We will be entitled to
          injunctive or other equitable relief (without the obligations of
          posting any bond or surety) in the event of any breach or anticipatory
          breach by you. The Service is not intended for distribution to or use
          by any person or entity in any jurisdiction or country where such
          distribution or use would be contrary to law or regulation.
          Accordingly, those persons who choose to access our Service from other
          locations do so on their own initiative and are solely responsible for
          compliance with local laws, if and to the extent local laws are
          applicable. These Terms (which include and incorporate our Privacy
          Policy) contains the entire understanding, and supersedes all prior
          understandings, between you and us concerning its subject matter, and
          cannot be changed or modified by you. The section headings used in
          this Agreement are for convenience only and will not be given any
          legal import.
        </StyledParagraph>

        <StyledStrongParagraph>
          <StyledStrong>Governing Law</StyledStrong>
        </StyledStrongParagraph>
        <StyledParagraph>
          These Terms shall be governed by and construed in all respects in
          accordance with the laws of Malaysia.
        </StyledParagraph>

        <StyledStrongParagraph>
          <StyledStrong>Disclaimer</StyledStrong>
        </StyledStrongParagraph>
        <StyledParagraph>
          We are not responsible for any content, code or any other imprecision.
          We do not provide warranties or guarantees. In no event shall we be
          liable for any special, direct, indirect, consequential, or incidental
          damages or any damages whatsoever, whether in an action of contract,
          negligence or other tort, arising out of or in connection with the use
          of the Service or the contents of the Service. We reserve the right to
          make additions, deletions, or modifications to the contents on the
          Service at any time without prior notice.
        </StyledParagraph>

        <StyledStrongParagraph>
          <StyledStrong>Contact Us</StyledStrong>
        </StyledStrongParagraph>
        <StyledUlParagraph>
          Don't hesitate to contact us if you have any questions.
          <br />
        </StyledUlParagraph>
        <StyledUl>
          <li>Via Email:&nbsp;support@caricarz.com</li>
        </StyledUl>
      </div>
    </div>
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default TermOfUseScreen;
